var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDataSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83335 14.0003H5.16669V46.667C5.16669 49.2337 7.26669 51.3337 9.83335 51.3337H42.5V46.667H9.83335V14.0003ZM47.1667 4.66699H19.1667C16.6 4.66699 14.5 6.76699 14.5 9.33366V37.3337C14.5 39.9003 16.6 42.0003 19.1667 42.0003H47.1667C49.7334 42.0003 51.8334 39.9003 51.8334 37.3337V9.33366C51.8334 6.76699 49.7334 4.66699 47.1667 4.66699ZM44.8334 25.667H35.5V35.0003H30.8334V25.667H21.5V21.0003H30.8334V11.667H35.5V21.0003H44.8334V25.667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDataSend);
export default __webpack_public_path__ + "static/media/icon_data_send.3c47643f50b956434ad3769ac1cd5fb9.svg";
export { ForwardRef as ReactComponent };